export default __webpack_public_path__ + "static/media/disability.c938d575.png";